var map = {
	"./add-icon--small.svg": 7635,
	"./add_image.svg": 4430,
	"./addevents-header-icon.svg": 37769,
	"./arrow-down.svg": 81074,
	"./arrow-up.svg": 1358,
	"./back-arrow.svg": 54776,
	"./ball.svg": 87092,
	"./bar-beverage.svg": 92606,
	"./bar-settings.svg": 66639,
	"./bg-events.jpg": 59205,
	"./calender.svg": 59863,
	"./cast.svg": 6579,
	"./channels/48pxIcons/Australian/10 bold 1.svg": 49397,
	"./channels/48pxIcons/Australian/7Mate Brisbane.svg": 77668,
	"./channels/48pxIcons/Australian/7Mate Melbourne.svg": 85555,
	"./channels/48pxIcons/Australian/7Mate Sydney.svg": 1638,
	"./channels/48pxIcons/Australian/7TWO 1.svg": 14516,
	"./channels/48pxIcons/Australian/7TWO Brisbane.svg": 81654,
	"./channels/48pxIcons/Australian/7TWO Melbourne.svg": 4559,
	"./channels/48pxIcons/Australian/7TWO Perth.svg": 90894,
	"./channels/48pxIcons/Australian/7TWO Sydney.svg": 97910,
	"./channels/48pxIcons/Australian/7mate Adelaide 1.svg": 57370,
	"./channels/48pxIcons/Australian/7mate Perth.svg": 37891,
	"./channels/48pxIcons/Australian/9Gem 1.svg": 30165,
	"./channels/48pxIcons/Australian/9go 1.svg": 83081,
	"./channels/48pxIcons/Australian/ABC 1.svg": 96124,
	"./channels/48pxIcons/Australian/ABC QLD.svg": 98515,
	"./channels/48pxIcons/Australian/ABC SA.svg": 34643,
	"./channels/48pxIcons/Australian/ABC VIC.svg": 57864,
	"./channels/48pxIcons/Australian/ABC WA.svg": 73728,
	"./channels/48pxIcons/Australian/Australia Plus 1.svg": 32063,
	"./channels/48pxIcons/Australian/Channel 10 Brisbane.svg": 31505,
	"./channels/48pxIcons/Australian/Channel 10 Melbourne.svg": 29267,
	"./channels/48pxIcons/Australian/Channel 10 Perth.svg": 83644,
	"./channels/48pxIcons/Australian/Channel 10 Sydney.svg": 75066,
	"./channels/48pxIcons/Australian/Channel 10.svg": 25953,
	"./channels/48pxIcons/Australian/Channel 7 Brisbane.svg": 4174,
	"./channels/48pxIcons/Australian/Channel 7 Melbourne.svg": 5786,
	"./channels/48pxIcons/Australian/Channel 7 Perth.svg": 15514,
	"./channels/48pxIcons/Australian/Channel 7 Sydney.svg": 97993,
	"./channels/48pxIcons/Australian/Channel 7.svg": 92971,
	"./channels/48pxIcons/Australian/Channel 9 Brisbane.svg": 44542,
	"./channels/48pxIcons/Australian/Channel 9 Melbourne.svg": 49953,
	"./channels/48pxIcons/Australian/Channel 9 Perth.svg": 44164,
	"./channels/48pxIcons/Australian/Channel 9 Sydney.svg": 23784,
	"./channels/48pxIcons/Australian/Channel 9.svg": 22393,
	"./channels/48pxIcons/Australian/Chelsea TV.svg": 19777,
	"./channels/48pxIcons/Australian/ESPN.svg": 98614,
	"./channels/48pxIcons/Australian/ESPN2.svg": 59266,
	"./channels/48pxIcons/Australian/Epicentre.TV.svg": 91535,
	"./channels/48pxIcons/Australian/Eurosport.svg": 63629,
	"./channels/48pxIcons/Australian/Fox Cricket.svg": 83052,
	"./channels/48pxIcons/Australian/Fox Footy.svg": 60502,
	"./channels/48pxIcons/Australian/Fox League.svg": 82320,
	"./channels/48pxIcons/Australian/Fox Sports 503.svg": 7493,
	"./channels/48pxIcons/Australian/Fox Sports 505.svg": 76501,
	"./channels/48pxIcons/Australian/Fox Sports 506.svg": 9104,
	"./channels/48pxIcons/Australian/Fox Sports More.svg": 36007,
	"./channels/48pxIcons/Australian/Fox Ultra HD.svg": 12930,
	"./channels/48pxIcons/Australian/Kayo Sports.svg": 84345,
	"./channels/48pxIcons/Australian/LFCTV.svg": 80497,
	"./channels/48pxIcons/Australian/MUTV.svg": 25951,
	"./channels/48pxIcons/Australian/Main Event.svg": 17596,
	"./channels/48pxIcons/Australian/NITV.svg": 67869,
	"./channels/48pxIcons/Australian/Netball Live.svg": 64034,
	"./channels/48pxIcons/Australian/Optus sport.svg": 45457,
	"./channels/48pxIcons/Australian/RAI Italia.svg": 63987,
	"./channels/48pxIcons/Australian/Racing.com.svg": 4649,
	"./channels/48pxIcons/Australian/SBS SA.svg": 71162,
	"./channels/48pxIcons/Australian/SBS Sydney.svg": 41479,
	"./channels/48pxIcons/Australian/SBS Viceland.svg": 98223,
	"./channels/48pxIcons/Australian/SBS WA.svg": 93150,
	"./channels/48pxIcons/Australian/SBS.svg": 19904,
	"./channels/48pxIcons/Australian/SKY Racing 2.svg": 89606,
	"./channels/48pxIcons/Australian/SKY Racing.svg": 80832,
	"./channels/48pxIcons/Australian/Sport Plus TV.svg": 27794,
	"./channels/48pxIcons/Australian/Stan Sport.svg": 79320,
	"./channels/48pxIcons/Australian/TV5MONDE Pacific.svg": 63756,
	"./channels/48pxIcons/Australian/Telstra TV.svg": 31817,
	"./channels/48pxIcons/Australian/beIN SPORTS 2.svg": 53755,
	"./channels/48pxIcons/Australian/beIN SPORTS 3.svg": 19097,
	"./channels/48pxIcons/Australian/beIN SPORTS.svg": 66213,
	"./channels/48pxIcons/Danish/3-Max.svg": 84538,
	"./channels/48pxIcons/Danish/3-Plus.svg": 85730,
	"./channels/48pxIcons/Danish/3-Sport.svg": 19009,
	"./channels/48pxIcons/Danish/6-eren.svg": 93454,
	"./channels/48pxIcons/Danish/9-eren.svg": 8205,
	"./channels/48pxIcons/Danish/C-More.svg": 59793,
	"./channels/48pxIcons/Danish/Canal-8-Sport.svg": 60314,
	"./channels/48pxIcons/Danish/DR1.svg": 71122,
	"./channels/48pxIcons/Danish/DR2.svg": 16544,
	"./channels/48pxIcons/Danish/DR3.svg": 57528,
	"./channels/48pxIcons/Danish/Eurosport-1.svg": 41091,
	"./channels/48pxIcons/Danish/Eurosport-2.svg": 93411,
	"./channels/48pxIcons/Danish/Eurosport-Player.svg": 60498,
	"./channels/48pxIcons/Danish/Kanal-5.svg": 99107,
	"./channels/48pxIcons/Danish/See.svg": 4579,
	"./channels/48pxIcons/Danish/Strive.svg": 44547,
	"./channels/48pxIcons/Danish/TV2-Sport.svg": 16080,
	"./channels/48pxIcons/Danish/TV2.svg": 25065,
	"./channels/48pxIcons/Danish/TV3-Sport-2.svg": 34329,
	"./channels/48pxIcons/Danish/Viasat-Golf.svg": 56475,
	"./channels/48pxIcons/Danish/Viasat-Xtra.svg": 23358,
	"./channels/48pxIcons/Danish/Xee.svg": 34374,
	"./channels/48pxIcons/Danish/dPlay.svg": 83672,
	"./channels/48pxIcons/Danish/viaplay.svg": 18769,
	"./channels/48pxIcons/Finland/C More Golf.svg": 89566,
	"./channels/48pxIcons/Finland/C More Max.svg": 53269,
	"./channels/48pxIcons/Finland/C More Sport 1.svg": 42363,
	"./channels/48pxIcons/Finland/C More Sport 2.svg": 88442,
	"./channels/48pxIcons/Finland/Elisa Viihde Sport.svg": 38470,
	"./channels/48pxIcons/Finland/Eurosport 2.svg": 37838,
	"./channels/48pxIcons/Finland/Eurosport.svg": 6201,
	"./channels/48pxIcons/Finland/MTV3.svg": 44511,
	"./channels/48pxIcons/Finland/Ruutu+ Urheliu 1.svg": 38842,
	"./channels/48pxIcons/Finland/Ruutu+ Urheliu 2.svg": 39755,
	"./channels/48pxIcons/Finland/Ruutu+ Urheliu 3.svg": 2683,
	"./channels/48pxIcons/Finland/Ruutu+ Urheliu 4.svg": 68280,
	"./channels/48pxIcons/Finland/Ruutu+ Urheliu 5.svg": 32495,
	"./channels/48pxIcons/Finland/Ruutu+ Urheliu 6.svg": 97664,
	"./channels/48pxIcons/Finland/Ruutu+ Urheliu 7.svg": 33221,
	"./channels/48pxIcons/Finland/Ruutu+ Urheliu 8.svg": 30186,
	"./channels/48pxIcons/Finland/Ruutu+.svg": 86069,
	"./channels/48pxIcons/Finland/Sub.svg": 65017,
	"./channels/48pxIcons/Finland/Telia.svg": 9241,
	"./channels/48pxIcons/Finland/Unibet TV.svg": 77288,
	"./channels/48pxIcons/Finland/Viasat Fotboll.svg": 99027,
	"./channels/48pxIcons/Finland/Viasat Golf.svg": 71925,
	"./channels/48pxIcons/Finland/Viasat Hockey.svg": 68443,
	"./channels/48pxIcons/Finland/Viasat Jalkapallo.svg": 54925,
	"./channels/48pxIcons/Finland/Viasat Jääkiekko.svg": 22119,
	"./channels/48pxIcons/Finland/Viasat Sport Live 1.svg": 84053,
	"./channels/48pxIcons/Finland/Viasat Sport Live 2.svg": 47349,
	"./channels/48pxIcons/Finland/Viasat Sport Live 3.svg": 2786,
	"./channels/48pxIcons/Finland/Viasat Sport Live 4.svg": 10404,
	"./channels/48pxIcons/Finland/Viasat Sport Live 5.svg": 86607,
	"./channels/48pxIcons/Finland/Viasat Sport Premium.svg": 75185,
	"./channels/48pxIcons/Finland/Viasat Sport Ultra HD.svg": 57344,
	"./channels/48pxIcons/Finland/Viasat Sport.svg": 9504,
	"./channels/48pxIcons/Finland/Viasat Urheilu.svg": 21357,
	"./channels/48pxIcons/Finland/YLE Areena.svg": 31127,
	"./channels/48pxIcons/Finland/Yle FEM.svg": 59167,
	"./channels/48pxIcons/Finland/Yle TV1.svg": 54396,
	"./channels/48pxIcons/Finland/Yle TV2.svg": 53143,
	"./channels/48pxIcons/Germany/ARD-alpha.svg": 19747,
	"./channels/48pxIcons/Germany/Amazon Prime DE.svg": 2947,
	"./channels/48pxIcons/Germany/BR.svg": 53028,
	"./channels/48pxIcons/Germany/DAZN.svg": 49433,
	"./channels/48pxIcons/Germany/Das Erste.svg": 92316,
	"./channels/48pxIcons/Germany/Einsfestival.svg": 5897,
	"./channels/48pxIcons/Germany/Eurosport 1.svg": 87230,
	"./channels/48pxIcons/Germany/Eurosport 2 Xtra.svg": 38223,
	"./channels/48pxIcons/Germany/Eurosport 2.svg": 35881,
	"./channels/48pxIcons/Germany/Eurosport Player DE.svg": 57835,
	"./channels/48pxIcons/Germany/HR.svg": 49981,
	"./channels/48pxIcons/Germany/Hamburg 1.svg": 16153,
	"./channels/48pxIcons/Germany/Kabel eins.svg": 33577,
	"./channels/48pxIcons/Germany/LAOLA1.svg": 72570,
	"./channels/48pxIcons/Germany/MDR.svg": 93749,
	"./channels/48pxIcons/Germany/Magenta Sport.svg": 96269,
	"./channels/48pxIcons/Germany/Motorvision TV.svg": 96438,
	"./channels/48pxIcons/Germany/N-TV.svg": 31230,
	"./channels/48pxIcons/Germany/NDR.svg": 94478,
	"./channels/48pxIcons/Germany/ProSieben Fun.svg": 3726,
	"./channels/48pxIcons/Germany/ProSieben MAXX.svg": 3258,
	"./channels/48pxIcons/Germany/RBB.svg": 88244,
	"./channels/48pxIcons/Germany/RTL II.svg": 80519,
	"./channels/48pxIcons/Germany/RTL NITRO.svg": 56748,
	"./channels/48pxIcons/Germany/RTL.svg": 86976,
	"./channels/48pxIcons/Germany/SAT.1 Gold.svg": 62662,
	"./channels/48pxIcons/Germany/SAT.1.svg": 68897,
	"./channels/48pxIcons/Germany/SPORT1+.svg": 77297,
	"./channels/48pxIcons/Germany/SPORT1.svg": 23681,
	"./channels/48pxIcons/Germany/SR Fernsehen.svg": 32233,
	"./channels/48pxIcons/Germany/SWR BW.svg": 13680,
	"./channels/48pxIcons/Germany/SWR RP.svg": 41384,
	"./channels/48pxIcons/Germany/SWR.svg": 90532,
	"./channels/48pxIcons/Germany/ServusTV Deutschland.svg": 20702,
	"./channels/48pxIcons/Germany/Sky Bundesliga 1.svg": 44933,
	"./channels/48pxIcons/Germany/Sky Bundesliga 2.svg": 84499,
	"./channels/48pxIcons/Germany/Sky Bundesliga 3.svg": 58840,
	"./channels/48pxIcons/Germany/Sky Bundesliga 4.svg": 11048,
	"./channels/48pxIcons/Germany/Sky Bundesliga 5.svg": 13602,
	"./channels/48pxIcons/Germany/Sky Bundesliga 6.svg": 62417,
	"./channels/48pxIcons/Germany/Sky Bundesliga 7.svg": 27346,
	"./channels/48pxIcons/Germany/Sky Bundesliga 8.svg": 40139,
	"./channels/48pxIcons/Germany/Sky Bundesliga 9.svg": 32599,
	"./channels/48pxIcons/Germany/Sky Bundesliga UHD.svg": 11742,
	"./channels/48pxIcons/Germany/Sky Bundesliga.svg": 83469,
	"./channels/48pxIcons/Germany/Sky Sport 1.svg": 8329,
	"./channels/48pxIcons/Germany/Sky Sport 10.svg": 29014,
	"./channels/48pxIcons/Germany/Sky Sport 11.svg": 25757,
	"./channels/48pxIcons/Germany/Sky Sport 2.svg": 78073,
	"./channels/48pxIcons/Germany/Sky Sport 3.svg": 13748,
	"./channels/48pxIcons/Germany/Sky Sport 4.svg": 26311,
	"./channels/48pxIcons/Germany/Sky Sport 5.svg": 4476,
	"./channels/48pxIcons/Germany/Sky Sport 6.svg": 98312,
	"./channels/48pxIcons/Germany/Sky Sport 7.svg": 65772,
	"./channels/48pxIcons/Germany/Sky Sport 8.svg": 92005,
	"./channels/48pxIcons/Germany/Sky Sport 9.svg": 92150,
	"./channels/48pxIcons/Germany/Sky Sport News.svg": 41412,
	"./channels/48pxIcons/Germany/Sky Ticket.svg": 71395,
	"./channels/48pxIcons/Germany/Sky Ultra HD.svg": 38762,
	"./channels/48pxIcons/Germany/Sportdeutschland.TV.svg": 69230,
	"./channels/48pxIcons/Germany/Sportdigital.svg": 59517,
	"./channels/48pxIcons/Germany/TV5MONDE Europe.svg": 20875,
	"./channels/48pxIcons/Germany/TVNOW.svg": 17698,
	"./channels/48pxIcons/Germany/WDR.svg": 89213,
	"./channels/48pxIcons/Germany/ZDF.svg": 52981,
	"./channels/48pxIcons/Germany/eSports1.svg": 94015,
	"./channels/48pxIcons/NewZealand/Duke.svg": 94198,
	"./channels/48pxIcons/NewZealand/ESPN 2.svg": 49384,
	"./channels/48pxIcons/NewZealand/ESPN.svg": 82185,
	"./channels/48pxIcons/NewZealand/Prime.svg": 95463,
	"./channels/48pxIcons/NewZealand/Rugby Channel.svg": 36063,
	"./channels/48pxIcons/NewZealand/SKY Sport Pop Up 1.svg": 34789,
	"./channels/48pxIcons/NewZealand/SKY Sport Pop Up 2.svg": 45692,
	"./channels/48pxIcons/NewZealand/Sky Arena.svg": 23201,
	"./channels/48pxIcons/NewZealand/Sky Sport 2.svg": 94147,
	"./channels/48pxIcons/NewZealand/Sky Sport 3.svg": 92957,
	"./channels/48pxIcons/NewZealand/Sky Sport 4.svg": 52081,
	"./channels/48pxIcons/NewZealand/Sky Sport 5.svg": 68339,
	"./channels/48pxIcons/NewZealand/Sky Sport 6.svg": 98120,
	"./channels/48pxIcons/NewZealand/Sky Sport 7.svg": 93761,
	"./channels/48pxIcons/NewZealand/Sky Sport 8.svg": 85285,
	"./channels/48pxIcons/NewZealand/Sky Sport 9.svg": 86616,
	"./channels/48pxIcons/NewZealand/Sky Sport Select.svg": 66754,
	"./channels/48pxIcons/NewZealand/Sky Sport.svg": 11766,
	"./channels/48pxIcons/NewZealand/Spark Sport.svg": 30316,
	"./channels/48pxIcons/NewZealand/TV5MONDE Pacific.svg": 82432,
	"./channels/48pxIcons/NewZealand/TVNZ+.svg": 98581,
	"./channels/48pxIcons/NewZealand/Trackside 1.svg": 74133,
	"./channels/48pxIcons/NewZealand/Trackside 2.svg": 81915,
	"./channels/48pxIcons/NewZealand/beIN SPORTS 2.svg": 10076,
	"./channels/48pxIcons/NewZealand/beIN SPORTS 3.svg": 18484,
	"./channels/48pxIcons/NewZealand/beIN SPORTS Pop-up 2.svg": 73570,
	"./channels/48pxIcons/NewZealand/beIN SPORTS Pop-up.svg": 74360,
	"./channels/48pxIcons/NewZealand/beIN SPORTS XTRA.svg": 64578,
	"./channels/48pxIcons/NewZealand/beIN SPORTS.svg": 50608,
	"./channels/48pxIcons/Norway/Betsafe NO.svg": 69438,
	"./channels/48pxIcons/Norway/Betsson NO.svg": 6262,
	"./channels/48pxIcons/Norway/Direktesport.svg": 49866,
	"./channels/48pxIcons/Norway/ESportsTV.svg": 49482,
	"./channels/48pxIcons/Norway/Eurosport 1.svg": 86008,
	"./channels/48pxIcons/Norway/Eurosport Norge.svg": 70469,
	"./channels/48pxIcons/Norway/Eurosport Player NO.svg": 26524,
	"./channels/48pxIcons/Norway/Eurosport Pluss 1.svg": 55120,
	"./channels/48pxIcons/Norway/Eurosport Pluss 2.svg": 48406,
	"./channels/48pxIcons/Norway/Eurosport Pluss 3.svg": 555,
	"./channels/48pxIcons/Norway/Eurosport Pluss 4-1.svg": 18310,
	"./channels/48pxIcons/Norway/Eurosport Pluss 4.svg": 19634,
	"./channels/48pxIcons/Norway/MAX.svg": 10150,
	"./channels/48pxIcons/Norway/NRK 1.svg": 23125,
	"./channels/48pxIcons/Norway/NRK 2.svg": 16631,
	"./channels/48pxIcons/Norway/NRK 3.svg": 45114,
	"./channels/48pxIcons/Norway/Strive Sport TV.svg": 10996,
	"./channels/48pxIcons/Norway/Strive Sport.svg": 6666,
	"./channels/48pxIcons/Norway/Strive.svg": 9691,
	"./channels/48pxIcons/Norway/TV 2 Sport 1.svg": 26146,
	"./channels/48pxIcons/Norway/TV 2 Sport 2.svg": 66001,
	"./channels/48pxIcons/Norway/TV 2 Sport Premium 2.svg": 24669,
	"./channels/48pxIcons/Norway/TV 2 Sport Premium 3.svg": 27539,
	"./channels/48pxIcons/Norway/TV 2 Sport Premium.svg": 37114,
	"./channels/48pxIcons/Norway/TV 2 Sportskanalen.svg": 12933,
	"./channels/48pxIcons/Norway/TV 2 Zebra.svg": 32265,
	"./channels/48pxIcons/Norway/TV 2.svg": 94088,
	"./channels/48pxIcons/Norway/TV2 Sumo.svg": 18675,
	"./channels/48pxIcons/Norway/TVNorge.svg": 53041,
	"./channels/48pxIcons/Norway/V Sport +.svg": 70740,
	"./channels/48pxIcons/Norway/V Sport Live 1.svg": 41380,
	"./channels/48pxIcons/Norway/V Sport Live 2.svg": 49553,
	"./channels/48pxIcons/Norway/V Sport Live 3.svg": 12065,
	"./channels/48pxIcons/Norway/V Sport Live 4.svg": 51037,
	"./channels/48pxIcons/Norway/V Sport Live 5.svg": 70472,
	"./channels/48pxIcons/Norway/VG+.svg": 43650,
	"./channels/48pxIcons/Norway/VOX.svg": 48375,
	"./channels/48pxIcons/Norway/Viaplay Kjøp.svg": 26006,
	"./channels/48pxIcons/Norway/Viasat 4.svg": 56579,
	"./channels/48pxIcons/Norway/Viasat Golf.svg": 86405,
	"./channels/48pxIcons/Norway/Viasport +.svg": 98409,
	"./channels/48pxIcons/Norway/Viasport 1.svg": 10421,
	"./channels/48pxIcons/Norway/Viasport 2.svg": 10904,
	"./channels/48pxIcons/Norway/Viasport 3.svg": 37809,
	"./channels/48pxIcons/Norway/Viasport Ultra HD.svg": 80102,
	"./channels/48pxIcons/Swedish/ATG.svg": 29088,
	"./channels/48pxIcons/Swedish/Aftonbladet Plus.svg": 79866,
	"./channels/48pxIcons/Swedish/Bet 365.svg": 5665,
	"./channels/48pxIcons/Swedish/C More Fotboll.svg": 58848,
	"./channels/48pxIcons/Swedish/C More Hockey.svg": 19733,
	"./channels/48pxIcons/Swedish/C More Live 1.svg": 49608,
	"./channels/48pxIcons/Swedish/C More Live 2.svg": 48374,
	"./channels/48pxIcons/Swedish/C More Live 3.svg": 73078,
	"./channels/48pxIcons/Swedish/C More Live 4 1.svg": 78130,
	"./channels/48pxIcons/Swedish/C More Live 4.svg": 4693,
	"./channels/48pxIcons/Swedish/Hajper.svg": 41049,
	"./channels/48pxIcons/Swedish/Kanal 5.svg": 44723,
	"./channels/48pxIcons/Swedish/Kanal 9.svg": 20808,
	"./channels/48pxIcons/Swedish/Kunskapskanalen.svg": 74504,
	"./channels/48pxIcons/Swedish/SVT 24.svg": 19218,
	"./channels/48pxIcons/Swedish/SVT Play.svg": 81087,
	"./channels/48pxIcons/Swedish/SVT1.svg": 74126,
	"./channels/48pxIcons/Swedish/SVT2.svg": 42946,
	"./channels/48pxIcons/Swedish/Sjuan.svg": 49245,
	"./channels/48pxIcons/Swedish/Sport Expressen.svg": 16529,
	"./channels/48pxIcons/Swedish/Sport Kanalen.svg": 49283,
	"./channels/48pxIcons/Swedish/TV 12.svg": 79918,
	"./channels/48pxIcons/Swedish/TV 4.svg": 83981,
	"./channels/48pxIcons/Swedish/TV 6.svg": 7935,
	"./channels/48pxIcons/Swedish/TV10.svg": 3802,
	"./channels/48pxIcons/Swedish/TV3 Sport.svg": 66293,
	"./channels/48pxIcons/Swedish/Tv 3.svg": 49080,
	"./channels/48pxIcons/Swedish/Tv4 play.svg": 9792,
	"./channels/48pxIcons/Swedish/V Sport ultra hd 1.svg": 62264,
	"./channels/48pxIcons/Swedish/V sport football 1.svg": 38731,
	"./channels/48pxIcons/Swedish/V sport hockey 1.svg": 86697,
	"./channels/48pxIcons/Swedish/VSport1.svg": 60162,
	"./channels/48pxIcons/Swedish/VSportMotor.svg": 37506,
	"./channels/48pxIcons/Swedish/VSport_premium.svg": 86797,
	"./channels/48pxIcons/Swedish/Viasat Sport Extra.svg": 50433,
	"./channels/48pxIcons/Swedish/sportbladet play.svg": 31839,
	"./channels/48pxIcons/UK/Amazon-Prime.svg": 22126,
	"./channels/48pxIcons/UK/BBC-Alba.svg": 22882,
	"./channels/48pxIcons/UK/BBC-Northern-Ireland.svg": 4671,
	"./channels/48pxIcons/UK/BBC-Red-Button.svg": 82785,
	"./channels/48pxIcons/UK/BBC-Scotland.svg": 76762,
	"./channels/48pxIcons/UK/BBC-Sport.svg": 34429,
	"./channels/48pxIcons/UK/BBC-Wales.svg": 9274,
	"./channels/48pxIcons/UK/BBC.svg": 21580,
	"./channels/48pxIcons/UK/BT-Sport-1.svg": 47838,
	"./channels/48pxIcons/UK/BT-Sport-2.svg": 26005,
	"./channels/48pxIcons/UK/BT-Sport-3.svg": 92699,
	"./channels/48pxIcons/UK/BT-Sport.svg": 68008,
	"./channels/48pxIcons/UK/Channel-4.svg": 74329,
	"./channels/48pxIcons/UK/Channel-5.svg": 18014,
	"./channels/48pxIcons/UK/Eleven-Sports.svg": 19674,
	"./channels/48pxIcons/UK/Eurosport.svg": 62767,
	"./channels/48pxIcons/UK/FreeSports.svg": 79844,
	"./channels/48pxIcons/UK/ITV-4.svg": 8658,
	"./channels/48pxIcons/UK/ITV-Sport.svg": 57209,
	"./channels/48pxIcons/UK/ITV.svg": 70045,
	"./channels/48pxIcons/UK/Premier-Sports.svg": 51858,
	"./channels/48pxIcons/UK/Prime-Video.svg": 49692,
	"./channels/48pxIcons/UK/Quest.svg": 77456,
	"./channels/48pxIcons/UK/Racing-TV.svg": 78020,
	"./channels/48pxIcons/UK/S4C.svg": 53983,
	"./channels/48pxIcons/UK/Sky-Sports-F1.svg": 76370,
	"./channels/48pxIcons/UK/Sky-Sports-Racing.svg": 8458,
	"./channels/48pxIcons/UK/Sky-Sports.svg": 10609,
	"./channels/48pxIcons/UK/Star-India.svg": 90350,
	"./channels/48pxIcons/UK/UEFA.svg": 59890,
	"./channels/48pxIcons/UK/Youtube.svg": 72469,
	"./channels/48pxIcons/default.svg": 92577,
	"./channels/Australian/10 bold 2.svg": 7733,
	"./channels/Australian/7Mate Brisbane.svg": 37874,
	"./channels/Australian/7Mate Melbourne.svg": 49318,
	"./channels/Australian/7Mate Sydney.svg": 87792,
	"./channels/Australian/7TWO 2.svg": 92498,
	"./channels/Australian/7TWO Brisbane.svg": 30497,
	"./channels/Australian/7TWO Melbourne.svg": 1822,
	"./channels/Australian/7TWO Perth.svg": 7598,
	"./channels/Australian/7TWO Sydney.svg": 11197,
	"./channels/Australian/7mate Adelaide 2.svg": 5972,
	"./channels/Australian/7mate Perth.svg": 27515,
	"./channels/Australian/9Gem 2.svg": 25727,
	"./channels/Australian/9go 2.svg": 5469,
	"./channels/Australian/ABC 2.svg": 94865,
	"./channels/Australian/ABC QLD.svg": 58845,
	"./channels/Australian/ABC SA.svg": 96222,
	"./channels/Australian/ABC VIC.svg": 16796,
	"./channels/Australian/ABC WA.svg": 31306,
	"./channels/Australian/Australia Plus 2.svg": 85316,
	"./channels/Australian/Channel 10 Brisbane.svg": 66873,
	"./channels/Australian/Channel 10 Melbourne.svg": 37897,
	"./channels/Australian/Channel 10 Perth.svg": 66116,
	"./channels/Australian/Channel 10 Sydney.svg": 51380,
	"./channels/Australian/Channel 10.svg": 66210,
	"./channels/Australian/Channel 7 Brisbane.svg": 69350,
	"./channels/Australian/Channel 7 Melbourne.svg": 5831,
	"./channels/Australian/Channel 7 Perth.svg": 42014,
	"./channels/Australian/Channel 7 Sydney.svg": 70091,
	"./channels/Australian/Channel 7.svg": 45101,
	"./channels/Australian/Channel 9 Brisbane.svg": 44972,
	"./channels/Australian/Channel 9 Melbourne.svg": 50197,
	"./channels/Australian/Channel 9 Perth.svg": 59635,
	"./channels/Australian/Channel 9 Sydney.svg": 94386,
	"./channels/Australian/Channel 9.svg": 61950,
	"./channels/Australian/Chelsea TV.svg": 86938,
	"./channels/Australian/ESPN.svg": 28117,
	"./channels/Australian/ESPN2.svg": 7093,
	"./channels/Australian/Epicentre.TV.svg": 69471,
	"./channels/Australian/Eurosport.svg": 33017,
	"./channels/Australian/Fox Cricket.svg": 56265,
	"./channels/Australian/Fox Footy.svg": 2551,
	"./channels/Australian/Fox League.svg": 91937,
	"./channels/Australian/Fox Sports 503.svg": 41419,
	"./channels/Australian/Fox Sports 505.svg": 1250,
	"./channels/Australian/Fox Sports 506.svg": 93248,
	"./channels/Australian/Fox Sports More.svg": 20454,
	"./channels/Australian/Fox Ultra HD.svg": 67062,
	"./channels/Australian/Kayo Sports.svg": 72158,
	"./channels/Australian/LFCTV.svg": 24798,
	"./channels/Australian/MUTV.svg": 72852,
	"./channels/Australian/Main Event.svg": 86262,
	"./channels/Australian/NITV.svg": 71589,
	"./channels/Australian/Netball Live.svg": 24324,
	"./channels/Australian/Optus sport.svg": 45452,
	"./channels/Australian/Prime.svg": 19853,
	"./channels/Australian/RAI Italia.svg": 27932,
	"./channels/Australian/Racing.com.svg": 73804,
	"./channels/Australian/SBS SA.svg": 13628,
	"./channels/Australian/SBS Sydney.svg": 55576,
	"./channels/Australian/SBS Viceland.svg": 40579,
	"./channels/Australian/SBS WA.svg": 11870,
	"./channels/Australian/SBS.svg": 42804,
	"./channels/Australian/SKY Racing 2.svg": 33848,
	"./channels/Australian/SKY Racing.svg": 73169,
	"./channels/Australian/Stan Sport Stan Sport.svg": 44361,
	"./channels/Australian/TV5MONDE Pacific.svg": 11245,
	"./channels/Australian/Telstra TV.svg": 13054,
	"./channels/Australian/beIN SPORTS 2.svg": 83172,
	"./channels/Australian/beIN SPORTS 3.svg": 79900,
	"./channels/Australian/beIN SPORTS.svg": 80211,
	"./channels/Danish/3-Max.svg": 75141,
	"./channels/Danish/3-Plus.svg": 5415,
	"./channels/Danish/3-Sport.svg": 95007,
	"./channels/Danish/6-eren.svg": 22425,
	"./channels/Danish/9-eren.svg": 89716,
	"./channels/Danish/C-More.svg": 99722,
	"./channels/Danish/Canal-8-Sport.svg": 75146,
	"./channels/Danish/DR1.svg": 72706,
	"./channels/Danish/DR2.svg": 79174,
	"./channels/Danish/DR3.svg": 80001,
	"./channels/Danish/Eurosport-1.svg": 142,
	"./channels/Danish/Eurosport-2.svg": 39198,
	"./channels/Danish/Eurosport-Player.svg": 9312,
	"./channels/Danish/Kanal-5.svg": 76491,
	"./channels/Danish/See.svg": 70649,
	"./channels/Danish/Strive.svg": 45211,
	"./channels/Danish/TV2-Sport.svg": 50909,
	"./channels/Danish/TV2.svg": 27855,
	"./channels/Danish/TV3-Sport-2.svg": 66726,
	"./channels/Danish/Viasat-Golf.svg": 21687,
	"./channels/Danish/Viasat-Xtra.svg": 36016,
	"./channels/Danish/Xee.svg": 42311,
	"./channels/Danish/dPlay.svg": 22452,
	"./channels/Danish/viaplay.svg": 6167,
	"./channels/NewZealand/Duke.svg": 12984,
	"./channels/NewZealand/ESPN 2.svg": 55488,
	"./channels/NewZealand/ESPN.svg": 16197,
	"./channels/NewZealand/Prime.svg": 79439,
	"./channels/NewZealand/Rugby Channel.svg": 95980,
	"./channels/NewZealand/SKY Sport Pop Up 1.svg": 41415,
	"./channels/NewZealand/SKY Sport Pop Up 2.svg": 25125,
	"./channels/NewZealand/Sky Arena.svg": 54793,
	"./channels/NewZealand/Sky Sport 10.svg": 79156,
	"./channels/NewZealand/Sky Sport 2.svg": 35738,
	"./channels/NewZealand/Sky Sport 3.svg": 78587,
	"./channels/NewZealand/Sky Sport 4.svg": 26255,
	"./channels/NewZealand/Sky Sport 5.svg": 16609,
	"./channels/NewZealand/Sky Sport 6.svg": 67219,
	"./channels/NewZealand/Sky Sport 7.svg": 25144,
	"./channels/NewZealand/Sky Sport 8.svg": 21076,
	"./channels/NewZealand/Sky Sport 9.svg": 1850,
	"./channels/NewZealand/Sky Sport Select.svg": 14920,
	"./channels/NewZealand/Sky Sport.svg": 52949,
	"./channels/NewZealand/Spark Sport.svg": 13173,
	"./channels/NewZealand/TV5MONDE Pacific.svg": 57451,
	"./channels/NewZealand/Trackside 1.svg": 76984,
	"./channels/NewZealand/Trackside 2.svg": 52737,
	"./channels/NewZealand/beIN SPORTS 2.svg": 83545,
	"./channels/NewZealand/beIN SPORTS Pop-up 2.svg": 17631,
	"./channels/NewZealand/beIN SPORTS Pop-up.svg": 44231,
	"./channels/NewZealand/beIN SPORTS.svg": 68613,
	"./channels/Swedish/Aftonbladet Plus.svg": 12682,
	"./channels/Swedish/Bet 365.svg": 71951,
	"./channels/Swedish/C More Fotboll.svg": 32264,
	"./channels/Swedish/C More Hockey.svg": 2609,
	"./channels/Swedish/C More Live 1.svg": 5090,
	"./channels/Swedish/C More Live 2.svg": 71807,
	"./channels/Swedish/C More Live 3.svg": 7690,
	"./channels/Swedish/C More Live 4.svg": 76449,
	"./channels/Swedish/Hajper.svg": 16770,
	"./channels/Swedish/Kanal 5.svg": 36573,
	"./channels/Swedish/Kanal 9.svg": 55878,
	"./channels/Swedish/Kunskapskanalen.svg": 39272,
	"./channels/Swedish/SVT 24.svg": 85680,
	"./channels/Swedish/SVT Play.svg": 36102,
	"./channels/Swedish/SVT1.svg": 94365,
	"./channels/Swedish/SVT2.svg": 40001,
	"./channels/Swedish/Sjuan.svg": 24285,
	"./channels/Swedish/Sport Expressen.svg": 31213,
	"./channels/Swedish/Sport Kanalen.svg": 10191,
	"./channels/Swedish/TV 12.svg": 35012,
	"./channels/Swedish/TV 4.svg": 14522,
	"./channels/Swedish/TV 6.svg": 7238,
	"./channels/Swedish/TV10.svg": 44283,
	"./channels/Swedish/TV3 Sport.svg": 1019,
	"./channels/Swedish/Tv 3.svg": 95829,
	"./channels/Swedish/Tv4 play.svg": 76602,
	"./channels/Swedish/VSport1.svg": 71510,
	"./channels/Swedish/VSportMotor.svg": 67261,
	"./channels/Swedish/VSport_premium.svg": 22753,
	"./channels/Swedish/Viasat Sport Extra.svg": 24953,
	"./channels/Swedish/sportbladet play.svg": 67199,
	"./channels/UK/Amazon-Prime.svg": 20792,
	"./channels/UK/BBC-Alba.svg": 10854,
	"./channels/UK/BBC-Northern-Ireland.svg": 32145,
	"./channels/UK/BBC-Red-Button.svg": 43671,
	"./channels/UK/BBC-Scotland.svg": 98167,
	"./channels/UK/BBC-Sport.svg": 57338,
	"./channels/UK/BBC-Wales.svg": 15449,
	"./channels/UK/BBC.svg": 60956,
	"./channels/UK/BT-Sport-1.svg": 8333,
	"./channels/UK/BT-Sport-2.svg": 95529,
	"./channels/UK/BT-Sport-3.svg": 15313,
	"./channels/UK/BT-Sport.svg": 46724,
	"./channels/UK/Channel-4.svg": 74859,
	"./channels/UK/Channel-5.svg": 64423,
	"./channels/UK/Eleven-Sports.svg": 84191,
	"./channels/UK/Eurosport.svg": 41714,
	"./channels/UK/FreeSports.svg": 42438,
	"./channels/UK/ITV-4.svg": 18600,
	"./channels/UK/ITV-Sport.svg": 79300,
	"./channels/UK/ITV.svg": 53721,
	"./channels/UK/Premier-Sports.svg": 79785,
	"./channels/UK/Prime-Video.svg": 58411,
	"./channels/UK/Quest.svg": 54224,
	"./channels/UK/Racing-TV.svg": 32840,
	"./channels/UK/S4C.svg": 80,
	"./channels/UK/Sky-Sports-F1.svg": 5000,
	"./channels/UK/Sky-Sports-Racing.svg": 39156,
	"./channels/UK/Sky-Sports.svg": 82390,
	"./channels/UK/Star-India.svg": 64831,
	"./channels/UK/UEFA.svg": 59290,
	"./channels/UK/Youtube.svg": 79250,
	"./channels/default.svg": 323,
	"./checkmark-icon.svg": 92044,
	"./close-icon.svg": 24514,
	"./close.svg": 32271,
	"./closeIcon.svg": 20868,
	"./custom-event.svg": 91617,
	"./dashboard-icon.svg": 95268,
	"./event-add-icon.svg": 30977,
	"./event-calendar.svg": 22886,
	"./event-delete-icon.svg": 8447,
	"./event-edit-icon.svg": 7445,
	"./event-star.svg": 97446,
	"./event-type-american-ball.svg": 12801,
	"./event-type-ball.svg": 5617,
	"./event-type-baseball.svg": 3208,
	"./event-type-custom.svg": 5713,
	"./event-type-hockey.svg": 28215,
	"./event-type-tennis.svg": 23122,
	"./event-type/american-football.svg": 79112,
	"./event-type/australian-football.svg": 43247,
	"./event-type/badminton.svg": 54891,
	"./event-type/baseball.svg": 80485,
	"./event-type/basketball.svg": 76903,
	"./event-type/cricket.svg": 83251,
	"./event-type/custom.svg": 94606,
	"./event-type/cycling.svg": 88256,
	"./event-type/fighting.svg": 76374,
	"./event-type/football.svg": 46304,
	"./event-type/gaa.svg": 27769,
	"./event-type/handball.svg": 61184,
	"./event-type/hockey.svg": 61239,
	"./event-type/horseracing.svg": 6038,
	"./event-type/other.svg": 41831,
	"./event-type/racing.svg": 57334,
	"./event-type/rugby-australian-football.svg": 23814,
	"./event-type/rugby.svg": 1190,
	"./event-type/tennis.svg": 96567,
	"./event-type/volleyball.svg": 49183,
	"./events-icon.svg": 89167,
	"./events/accept_reservation.svg": 84750,
	"./events/activity.svg": 37336,
	"./events/clone.svg": 84490,
	"./events/drink.svg": 23168,
	"./events/facebook.svg": 36751,
	"./events/instagram.svg": 11470,
	"./events/meetup.svg": 86728,
	"./events/more.svg": 47505,
	"./events/offer.svg": 74653,
	"./events/plus.svg": 80826,
	"./events/remove.svg": 35444,
	"./events/sportcompass-gray.svg": 88507,
	"./events/sportcompass.net.svg": 83962,
	"./events/sportcompass.svg": 92510,
	"./forward-arrow.svg": 5535,
	"./insights-icon.svg": 7017,
	"./leftArrow.svg": 42751,
	"./location.svg": 31537,
	"./logo-color-horizontal.svg": 7485,
	"./logo-without-text.svg": 93797,
	"./map.svg": 8132,
	"./message-dialog-config.svg": 17593,
	"./message-dialog-error.svg": 62764,
	"./message-dialog-success.svg": 40592,
	"./myschedule-header-icon.svg": 61773,
	"./new-logo.svg": 10065,
	"./notification.svg": 21151,
	"./promos-icon.svg": 15501,
	"./red-trashcan.svg": 59983,
	"./remove_image_icon.svg": 47331,
	"./reservation.svg": 97804,
	"./rightArrow.svg": 24717,
	"./scheduler.svg": 80961,
	"./searchIcon.svg": 19987,
	"./searchIconDisabled.svg": 39775,
	"./settings/Default-Bar-Cover.png": 4537,
	"./settings/fb-icon.svg": 16408,
	"./settings/filters-icon.svg": 21539,
	"./settings/filters.svg": 42250,
	"./settings/ig-icon.svg": 74651,
	"./settings/location-features/big-screen.svg": 32108,
	"./settings/location-features/bring-food.svg": 39332,
	"./settings/location-features/capacity.svg": 31927,
	"./settings/location-features/free-wifi.svg": 33553,
	"./settings/location-features/parking.svg": 16898,
	"./settings/location-features/screen.svg": 40779,
	"./settings/location-features/serves-food.svg": 29299,
	"./settings/location-image.svg": 87710,
	"./settings/parking.svg": 71216,
	"./settings/payment-icon.svg": 47147,
	"./settings/poster-settings-icon.svg": 3898,
	"./settings/settings.svg": 20357,
	"./settings/social-media-icon.svg": 94297,
	"./settings/social-media.svg": 23807,
	"./settings/user-company-icon.svg": 84423,
	"./settings/user-company.svg": 87486,
	"./settings/user-management-icon.svg": 11844,
	"./settings/user-preferences-icon.svg": 83563,
	"./settings/user-preferences.svg": 81883,
	"./settings/user-profile-icon.svg": 41452,
	"./settings/user-profile.svg": 57041,
	"./settings/widget-icon.svg": 59997,
	"./share-events-alert.svg": 86358,
	"./share-events-facebook.png": 80396,
	"./share-events-image-black.svg": 93872,
	"./share-events-image.svg": 78858,
	"./share-events-instagram.png": 76964,
	"./share-events-text-black.svg": 79420,
	"./share-events-text.svg": 13585,
	"./share-events-upload.svg": 28013,
	"./share-events-video-gray.svg": 53276,
	"./share-events-video.svg": 18180,
	"./smile-emoji-button.svg": 34032,
	"./upload.svg": 71968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93041;